import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import {
  ICustomerGenericService,
  IHIPGenericService,
  TableAction,
  TableHeader,
} from '@huge-monorepo/shared/interfaces';
import { Router } from '@angular/router';
import { SharedGenericSingletonService, SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-tasks',
  standalone: true,
  imports: [MatCardModule, MatProgressBarModule, ToolsModule, MaterialModule, CommonModule],
  templateUrl: './teltonika-tasks.component.html',
  styleUrl: './teltonika-tasks.component.scss',
})
export class TeltonikaTasksComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  finishedLoading: boolean = false;
  taskData: any[];

  tasksHeaders: TableHeader[] = [
    {
      ID: 'GroupName',
      Index: 1,
      Sort: 'GroupName',
      Sortable: false,
      Text: 'Task Group Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'TaskName',
      Index: 2,
      Sort: 'TaskName',
      Sortable: false,
      Text: 'Task Name',
      Type: String,
      Align: 'left',
    },
  ];

  taskActions: TableAction[] = [
    {
      Icon: 'visibility',
      Text: 'View',
      Caller: (p: any) => {
        if (p == null) {
          return;
        }

        this.router.navigate([`/Teltonika/Tasks/${p.ID}`]);
      },
    },
    {
      Icon: 'delete',
      Text: 'Delete',
      Caller: (p: any) => {
        if (p == null) {
          return;
        }

        this.deleteTask(p.ID);
      },
    },
  ];

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private router: Router,
    private genericService: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>
  ) { }

  ngOnInit() {
    this.teltonikaService.getTeltonikaTableTasks().subscribe((data) => {
      this.taskData = data;
      this.finishedLoading = true;
    });
  }

  onSearchChange(event: string) {
    this.finishedLoading = false;
    this.teltonikaService.getTeltonikaTableTasks(event).subscribe((data) => {
      this.taskData = data;
      this.finishedLoading = true;
    });
  }

  onAddChange(event: boolean) {
    this.router.navigate(['/Teltonika/Tasks/0']);
  }

  deleteTask(id: number) {
    this.finishedLoading = false;
    this.teltonikaService.deleteTeltonikaTask(id).subscribe({
      next: (data) => {
        this.genericService.service.createToast('Task deleted successfully', 'The task has been deleted successfully', 'success');
        // reload the table
        this.teltonikaService.getTeltonikaTableTasks().subscribe((data) => {
          this.taskData = data;
          this.finishedLoading = true;
        });
      },
      error: (error) => {
        console.error(error);
        this.genericService.service.createToast('Error deleting task', 'There was an error deleting the task', 'error');
        this.finishedLoading = true;
      },
    });
  }
}
